export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fb5951f99e373d6131d742f9441ae13ffd385c9ec&name=fetchTypeahead!'